import React from 'react';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import i18next from 'i18next';
import { renderDefaultGridCell } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/WorkExperienceTab/components/gridComponents/DefaultGridCell';
import { getAmount, getPercentage, validateAmount, validatePercentage } from './OrderTargetMarginHelper';
import TargetMarginPercentageCell from './TargetMarginPercentageCell';
import TargetMarginAmountCell from './TargetMarginAmountCell';

const targetMarginPercentageColumn = (field, headerKey, minWidth) => ({
  ...XGridDefaultColumn,
  field,
  headerName: i18next.t(headerKey),
  flex: 0,
  minWidth,
  type: 'number',
  editable: true,
  align: 'left',
  headerAlign: 'left',
  renderCell: params => renderDefaultGridCell({ ...params, value: getPercentage(Number(params?.value)) }),
  renderEditCell: params => <TargetMarginPercentageCell {...params} />,
  preProcessEditCellProps: params => ({
    ...params.props,
    error: !validatePercentage(params.props.value),
  }),
});

const targetMarginAmountColumn = (field, headerKey, minWidth) => ({
  ...XGridDefaultColumn,
  field,
  headerName: i18next.t(headerKey),
  flex: 0,
  minWidth,
  type: 'number',
  align: 'left',
  headerAlign: 'left',
  editable: true,
  renderCell: params => renderDefaultGridCell({ ...params, value: getAmount(Number(params?.value)) }),
  renderEditCell: params => <TargetMarginAmountCell {...params} />,
  preProcessEditCellProps: params => ({
    ...params.props,
    error: !validateAmount(params.props.value),
  }),
});

export const orderTargetMarginGridColumns = () => [
  {
    ...XGridDefaultColumn,
    field: 'discipline',
    headerName: i18next.t('order.orderDetails.preferences.targetMargins.grid.discipline'),
    flex: 0,
    minWidth: 170,
  },
  {
    ...XGridDefaultColumn,
    field: 'specialty',
    headerName: i18next.t('order.orderDetails.preferences.targetMargins.grid.specialty'),
    flex: 0,
    minWidth: 130,
  },
  {
    ...XGridDefaultColumn,
    field: 'subSpecialty',
    headerName: i18next.t('order.orderDetails.preferences.targetMargins.grid.subSpecialty'),
    flex: 0,
    minWidth: 140,
  },
  targetMarginPercentageColumn(
    'targetMarginDefault',
    'order.orderDetails.preferences.targetMargins.grid.targetMarginDefault',
    155,
  ),
  targetMarginPercentageColumn(
    'targetMarginDayShift',
    'order.orderDetails.preferences.targetMargins.grid.targetMarginDay',
    140,
  ),
  targetMarginPercentageColumn(
    'targetMarginNightShift',
    'order.orderDetails.preferences.targetMargins.grid.targetMarginNight',
    140,
  ),
  targetMarginPercentageColumn(
    'targetMarginDayNightShift',
    'order.orderDetails.preferences.targetMargins.grid.targetMarginDayNight',
    175,
  ),
  targetMarginPercentageColumn(
    'payRangeMinMaxPercentage',
    'order.orderDetails.preferences.targetMargins.grid.payRangeMinMaxPercentage',
    210,
  ),
  targetMarginAmountColumn(
    'defaultWeeklyPay',
    'order.orderDetails.preferences.targetMargins.grid.defaultWeeklyPay',
    140,
  ),
];
